var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAddMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8224 7.1776 32 16 32C24.8224 32 32 24.8224 32 16C32 7.1776 24.8224 0 16 0C7.1776 0 0 7.1776 0 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2681 10.5566C14.2681 11.5116 15.045 12.2886 16 12.2886C16.955 12.2886 17.732 11.5116 17.732 10.5566C17.732 9.60161 16.955 8.82466 16 8.82466C15.045 8.82466 14.2681 9.60161 14.2681 10.5566Z",
    fill: "#FD7E14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2681 21.4433C14.2681 22.3983 15.045 23.1753 16 23.1753C16.955 23.1753 17.732 22.3983 17.732 21.4433C17.732 20.4883 16.955 19.7114 16 19.7114C15.045 19.7114 14.2681 20.4883 14.2681 21.4433Z",
    fill: "#FD7E14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2681 16C14.2681 16.955 15.045 17.7319 16 17.7319C16.955 17.7319 17.732 16.955 17.732 16C17.732 15.045 16.955 14.268 16 14.268C15.045 14.268 14.2681 15.045 14.2681 16Z",
    fill: "#FD7E14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51469 7.51469C5.24825 9.78123 4 12.7947 4 16C4 19.2053 5.24825 22.2188 7.51469 24.4853C9.78123 26.7518 12.7947 28 16 28C19.2053 28 22.2188 26.7518 24.4853 24.4853C26.7518 22.2188 28 19.2053 28 16C28 12.7947 26.7518 9.78123 24.4853 7.51469C22.2188 5.24825 19.2053 4 16 4C12.7947 4 9.78123 5.24825 7.51469 7.51469ZM26.5155 16C26.5155 21.7983 21.7983 26.5155 16 26.5155C10.2017 26.5155 5.48454 21.7983 5.48454 16C5.48454 10.2017 10.2017 5.48454 16 5.48454C21.7983 5.48454 26.5155 10.2017 26.5155 16Z",
    fill: "#FD7E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAddMenu);
export default __webpack_public_path__ + "static/media/my_add_menu.1b0b9767ab39e0ea62dfa2266de0728a.svg";
export { ForwardRef as ReactComponent };